module.exports = __webpack_public_path__ + "img/reg.b7a7f31b.png";